import React, { useEffect, useRef, useContext } from "react";
import { FormControl, Select, MenuItem, Box, Badge } from "@mui/material";
import { useOrganizations, useSelectedOrganization, useTranslations } from "hooks";
import { Organization } from "model/organizationModel";
import { Notification } from "model/notificationsModel";
import { getTranslation } from "common";
import { Context as NotificationContext } from "contexts/notificationContext";

type NotificationsOrganizationsListProps = {
  value: number | null | 'all';
  onChange: (id: number | null) => void;
};

const NotificationsOrganizationsList: React.FC<NotificationsOrganizationsListProps> = ({
  value,
  onChange,
}) => {
  const [organizations] = useOrganizations();
  const selectedOrganization = useSelectedOrganization();
  const initialized = useRef(false);
  const translations = useTranslations()
  const notificationState = useContext(NotificationContext).state

  useEffect(() => {
    if (!initialized.current && selectedOrganization && selectedOrganization.id && organizations.length > 0) {
      initialized.current = true;
      onChange(selectedOrganization.id);
    }
  }, [selectedOrganization, organizations, onChange]);

  const handleChange = (event: { target: { value: unknown } }) => {
    initialized.current = true;
    const val = event.target.value as number | string;
    if (val === 'all') {
      onChange(null);
    } else {
      onChange(val as number);
    }
  };

  return (
    <Box sx={{ ml: 2 }}>
      <FormControl size="small">
        <Select
          value={value === null ? 'all' : value}
          onChange={handleChange}
          displayEmpty
        >
          <MenuItem value="all">
            {getTranslation(translations, "generic.notifications.all")}
          </MenuItem>
          {organizations.map((org: Organization) => {
            const unreadCount = notificationState.notificationList.filter(
              (n: Notification) => n.idorganization === org.id && !n.readed
            ).length;
            return (
              <MenuItem key={org.id} value={org.id}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                  <span>{org.name}</span>
                  {unreadCount > 0 && (
                    <Badge badgeContent={unreadCount} color="error" sx={{ ml: 6, mr: 2 }} />
                  )}
                </Box>
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Box>
  );
};

export default NotificationsOrganizationsList;
